






















import { Component, Vue, Prop, Model } from "vue-property-decorator";

@Component
export default class RadioButton extends Vue {
  @Model("change") readonly selected!: any;
  @Prop() readonly value!: any;
  @Prop() readonly name!: string;
  @Prop(Boolean) readonly column?: boolean;

  hover = false;
}
